module.exports = __webpack_public_path__ + "static/img/home_new21.29f83658.jpg";